<template>
  <div>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <div style="float:right;width: 1250px;color: #e6a23c;font-weight: bold"><marquee>{{noticeText}}</marquee></div>
    <el-breadcrumb-item v-if="$route.path!='/front/home'" to="/front/home">返回首页</el-breadcrumb-item>
    <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
  </el-breadcrumb>
  </div>
</template>

<script>
  export default {
    name: "sui-breadcrumb",
    computed: {
      noticeText() {
        return this.$store.getters.config.noticeText;
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sui-breadcrumb/sui-breadcrumb.vue